export const ADMIN = {
  MEETING_FORM_TYPE: {
    EDIT: "EDIT",
    CREATE: "CREATE",
  },
};
